import React, { useEffect, useRef, useState } from 'react';

import SVG from 'src/components/SvgIcon';

import styles from './FollowUpSelect.module.scss';

interface Option {
  value: string;
  label: string;
}

interface Props {
  label: string;
  value: string;
  options: Option[];
  placeholder?: string;
  onChange: (value: string) => void;
}

const FollowUpSelect: React.FC<Props> = ({
  label,
  value,
  options,
  placeholder,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const selectedLabel = options.find((o) => o.value === value)?.label;

  const handleSelect = (val: string) => {
    onChange(val);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      const handleClickOutside = (e: MouseEvent) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
          setIsOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);

      return () => document.removeEventListener('mousedown', handleClickOutside);
    }

    return undefined;
  }, [isOpen]);

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className={`${styles.triggerLabel}${isOpen ? ` ${styles.triggerLabelOpen}` : ''}`}>{label}</span>
        <div className={styles.triggerRight}>
          <span className={selectedLabel ? styles.selectedLabel : styles.placeholder}>
            {selectedLabel || placeholder}
          </span>
          <SVG id="arrowDown" />
        </div>
      </button>

      {isOpen && (
        <div className={styles.optionsList}>
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`${styles.option} ${opt.value === value ? styles.optionSelected : ''}`}
              onClick={() => handleSelect(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

FollowUpSelect.defaultProps = {
  placeholder: 'select',
};

export default FollowUpSelect;
